import { render, staticRenderFns } from "./ModalSolicitacaoDeOrcamento.vue?vue&type=template&id=5d146710&scoped=true"
import script from "./ModalSolicitacaoDeOrcamento.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSolicitacaoDeOrcamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalSolicitacaoDeOrcamento.vue?vue&type=style&index=0&id=5d146710&prod&scoped=true&lang=css"
import style1 from "./ModalSolicitacaoDeOrcamento.vue?vue&type=style&index=1&id=5d146710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d146710",
  null
  
)

export default component.exports